import { useMutation, useQuery } from '@tanstack/react-query';
import { customFetcher } from '../useFetch';
import { ICourt } from '../../Interfaces/ICourt';

export const useUpdateCourt = () => {
  const { mutateAsync: updateCourt, isPending: isPendingCourt } = useMutation({
    mutationFn: (court: ICourt) =>
      customFetcher({
        endpoint: '/court',
        method: 'PUT',
        body: court,
      }),
  });
  return {
    updateCourt,
    isPendingCourt,
  };
};

export const useGetCourt = () => {
  const { data: courtArray, isLoading: isLoadingCourtArray } = useQuery<any[]>({
    queryKey: ['court'],
    queryFn: () => customFetcher({ endpoint: '/court' }),
  });

  return { courtArray, isLoadingCourtArray };
};
